<template>
  <component class="is-hidden-print" v-bind:is="component" />
</template>

<script>
import Footer from '@/components/Footer/_Footer'
import GreenstormFooter from '@/components/Footer/Greenstorm'

export default {
  name: 'FooterProxy',
  components: {
    Footer,
    GreenstormFooter,
  },
  props: {},
  computed: {
    component: function() {
      switch (this.$whitelabel.short.toLowerCase()) {
        case 'greenstorm':
          return 'GreenstormFooter'
        default:
          return 'Footer'
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
